import RequestBase from './RequestBase';

export class SignContractRequest extends RequestBase {
    constructor(customerId, contractTypeId) {
        super();
        this._url = '/Contracts';
        this.method = 'POST';
        this.contentType = 'application/json';
        this.parameters = [
            'customerId',
            'contractTypeId'
        ];
        this.body = {
            'customerId': customerId,
            'contractTypeId': contractTypeId
        };
    }
}

export class GenerateContractRequest extends RequestBase {
    constructor(customerId, contractTypeId) {
        super();
        this._url = '/Contracts/{customerId}';
        this.method = 'GET';
        this.contentType = 'application/json';
        this.qs = {
            'contractTypeId': contractTypeId
        };
        this.customerId = customerId;
    }
}



// WEBPACK FOOTER //
// ./src/Resources/Contracts.js